import styled from "styled-components";

import * as Code from "ds/Code";

export const Wrapper = styled.div`
  margin-top: 24px;
`;

export const SelectWrapper = styled.div`
  width: max-content;
  min-width: 162px;
  max-width: 100%;
`;

export const FileExampleLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 48px;
  margin: 0 0 4px 0;
  label {
    margin-bottom: 0;
    color: var(--section-granite-color, var(--granite));
  }
`;

export const ExpandButton = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  svg {
    margin-right: 0;
    path {
      fill: var(--mode-vector-neutral-default);
    }
  }
  span {
    display: none;
  }
  &:hover {
    background-color: var(--input-ice-background-color, var(--ice));
    svg > path {
      fill: var(--icon-color-primary-600-fill, var(--color-primary-600));
    }
  }
`;

export const CodeBlock = styled(Code.Block)`
  min-height: 218px;
  height: 218px;
  overflow-y: scroll;
`;
